import React from "react";
import Sidebar from "../sidebar";
import Navbar from "../Navbar";
import { Outlet } from "react-router-dom";

const MainLayout: React.FC = () => {
  return (
    <div className="bg-gray-100 dark:bg-black">
      <div className="top-0 z-50">
        <Navbar />
      </div>
      <div className="flex min-h-full mt-6">
        <Sidebar />
        <div className="flex-1 px-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
